/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { Sexe } from '@/types';

/**
 * Options du champ « Sexe » avec les libellés de l'ETCV (Masculin / Féminin).
 *
 * Mêmes valeurs qu'`OPTIONS_SEXE` de la lib, qui affiche Homme / Femme pour les
 * autres applications : seuls les libellés changent.
 */
export const OPTIONS_SEXE_ETCV = [
  { key: 1, text: 'Masculin', value: Sexe.Homme },
  { key: 2, text: 'Féminin', value: Sexe.Femme },
];

/**
 * Les mêmes, plus « Indéterminé » (AD-12856), comme dans l'ETCV et le cahier
 * des charges. Réservé aux individus pour lesquels il est prévu : enfant de
 * reconnaissance, conjoints et leurs parents, défunt. JAMAIS la naissance.
 */
export const OPTIONS_SEXE_ETCV_AVEC_INDETERMINE = [
  ...OPTIONS_SEXE_ETCV,
  { key: 3, text: 'Indéterminé', value: Sexe.Indetermine },
];

export default OPTIONS_SEXE_ETCV;
